import GameEnd from './GameEnd'
import GameOver from './GameOver'
import type { RunEndStatsSummary } from './runEndStats'

type EndScreenProps = {
    isLevelComplete: boolean
    /** When false, `GameEnd` stays hidden until the level-complete card intro finishes. */
    showLevelCompleteUi: boolean
    isGameOver: boolean
    clampedDistance: number
    levelTargetDistance: number
    runStats: RunEndStatsSummary
    onReplay: () => void
    onOpenEditor: () => void
    /** Game over: "Aussehen ändern". Falls back to `onOpenEditor` if omitted. */
    onEditAppearance?: () => void
}

export default function EndScreen({
    isLevelComplete,
    showLevelCompleteUi,
    isGameOver,
    clampedDistance,
    levelTargetDistance,
    runStats,
    onReplay,
    onOpenEditor,
    onEditAppearance,
}: EndScreenProps) {
    const handleEditAppearance = onEditAppearance ?? onOpenEditor

    if (!isLevelComplete && !isGameOver) {
        return null
    }

    if (isLevelComplete) {
        return (
            <GameEnd
                showContent={showLevelCompleteUi}
                onReplay={onReplay}
                onOpenEditor={onOpenEditor}
            />
        )
    }

    return (
        <GameOver
            onReplay={onReplay}
            onEditAppearance={handleEditAppearance}
        />
    )
}
